export default __webpack_public_path__ + "static/media/esquinero.ff883eb4.png";